import ReportHit from "./ReportHit";

const CustomHits = ({
  hits = [],
  selectedReport,
  signIn,
  authState,
  openPDFWithPreSignedUrl,
  pdfLoading,
}) => (
  <>
    {hits.map((hit, index) => {
      const cleanedVolume = hit.volume_num
        ? String(parseInt(hit.volume_num.replace(/volume\s*/i, "").trim(), 10))
        : undefined;

      const key =
        hit.standard_casenumber ||
        hit.link ||
        `${hit.report || ""}-${hit.decision_year || ""}-${hit.nameofparties || ""}` ||
        `report-${index}`;

      return (
        <ReportHit
          key={key}
          hit={{ ...hit, volume_num: cleanedVolume }}
          selectedReport={selectedReport}
          signIn={signIn}
          authState={authState}
          openPDFWithPreSignedUrl={openPDFWithPreSignedUrl}
          pdfLoading={pdfLoading}
        />
      );
    })}
  </>
);

export default CustomHits;
